const state = {
  isDeferring: false,
}

const getters = {
  isDeferring: (moduleState) => moduleState.isDeferring,
}

const mutations = {
  setDeferring(moduleState, isDeferring) {
    moduleState.isDeferring = isDeferring // eslint-disable-line no-param-reassign
  },
}

const actions = {
  // No skip slides or marketplace catalogue: presenting needs both, so the deferring frame already has them.
  fetchEditorOnlyPresentationDataAction({ dispatch, rootGetters }, presentation) {
    if (!presentation?.id) return
    dispatch('themeModule/getThemesAction', null, { root: true })
    dispatch('themeModule/getOfficialThemesAction', null, { root: true })
    dispatch('presetModule/getPresetColorPalettesAction', null, { root: true })
    dispatch('themeModule/getTeamThemesAction', null, { root: true })
    dispatch('remoteControlLink/getRemoteLink', presentation, { root: true })
    dispatch('slideAttributes/getByKeys', {
      presentationId: presentation.id,
      attributeKeys: ['cloudImportSource'],
    }, { root: true })
    if (rootGetters['featureToggles/canUseNewSlideMarketPlace']) {
      dispatch('slideMarketplace/fetchPinnedSlideTypes', null, { root: true }).catch((err) => {
        // eslint-disable-next-line no-console
        console.error('Failed to pre-fetch pinned slide types:', err)
      })
    }
  },
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
}
